import { MessageAnt } from "../redux/slices/ui/uiAction";
import { MessageType } from "../types/messageType";

export const clipboard = async (copy) => {
	await navigator.clipboard.writeText(copy);
	MessageAnt(MessageType.success, "Copiado correctamente");
};
